var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('app-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }